export const jobAddDiscountsModalInitialState = {
  addDiscountsModal: {
    visible: false as boolean,
    eventIds: [] as string[],
    discountId: undefined as string | undefined,
    amount: undefined as number | undefined,
  },
} as const;

export type AddDiscountsModalState = typeof jobAddDiscountsModalInitialState;
